module.exports = __webpack_public_path__ + "img/Romantikken_Brudefærden-I-Hardanger.3cc0ca5f.jpg";